import {  Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'src/reducers';
import { useEffect, useState } from 'react';
import {  DashboardProjectExpenseRevenueDataRequest } from 'src/actions/dashboardActions';
import RenderGraph from './RenderGraph';

export default function DashboardProjectReveneExpenseSection() {

  const [ filter, setFilter] = useState<any>({type:1});
  const dispatch = useDispatch();
  const dashboardData = useSelector(state => state.dashboard);
  const { dashboardProjectExpenseRevenueSectionData } = dashboardData;

  var dates: any = [];
  var revenue: any = [];
  var expense: any = [];

  dashboardProjectExpenseRevenueSectionData.map((dara: any) =>
    dates.push(dara.date) && revenue.push(dara.revenue) && expense.push(dara.expense)
  );

  useEffect(() => {
    dispatch(DashboardProjectExpenseRevenueDataRequest(filter))
  }, [filter])

  const CHART_DATA = [
    {
      name: 'Revenue',
      data: revenue
    },
    {
      name: 'Expense',
      data: expense
    },
  ];


  var options: any = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: dates
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return "$ " + val
        }
      }
    }
  };

  return (
    <Grid item xs={12} md={6} lg={6}>
      <RenderGraph filterType={['']} filter={filter} setFilter={setFilter} title="Daily Revenue/Expense" subheader="This Year" chartdata={CHART_DATA} options={options} type="bar" />
    </Grid>
  );
}
